import React, { useEffect, useState } from 'react';
import { Spinner } from 'react-activity';
import 'react-activity/dist/library.css';

export const CommonLoaderBlue = ({ color }) => {
  const [size, setSize] = useState(16);

  useEffect(() => {
    const checkSize = () => {
      setSize(window.innerWidth >= 1024 ? 24 : 16); // lg breakpoint = 1024px
    };
    checkSize();
    window.addEventListener('resize', checkSize);

    return () => window.removeEventListener('resize', checkSize);
  }, []);

  return <Spinner color={color || 'royalblue'} size={size} />;
};
